"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Collection = _interopRequireDefault(require("../../Collection"));

var _client = _interopRequireDefault(require("../client"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* Collection generated by the Stories-API endpoint.
*/
var StoriesAPICollection =
/*#__PURE__*/
function (_Component) {
  _inherits(StoriesAPICollection, _Component);

  function StoriesAPICollection(props) {
    var _this;

    _classCallCheck(this, StoriesAPICollection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StoriesAPICollection).call(this, props));
    var apiKey = props.apiKey,
        data = props.data,
        page = props.page,
        endpoint = props.endpoint,
        q = props.q;
    _this.state = {
      loading: data ? false : true,
      data: data,
      count: null,
      stories: [],
      page: page || 1,
      search: q,
      q: q,
      error: false
    };
    _this.client = new _client.default(endpoint, apiKey);
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handlePageChange = _this.handlePageChange.bind(_assertThisInitialized(_this));
    _this.setError = _this.setError.bind(_assertThisInitialized(_this));
    _this.handleSearch = _this.handleSearch.bind(_assertThisInitialized(_this));
    _this.handleSearchInput = _this.handleSearchInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(StoriesAPICollection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.state.data) {
        this.setState({
          loading: true
        }, function () {
          _this2.fetchData(function () {
            _this2.fetchStories(function () {
              _this2.setState({
                loading: false
              });
            });
          });
        });
      }
    }
  }, {
    key: "setError",
    value: function setError() {
      this.setState({
        error: true
      });
    }
  }, {
    key: "fetchData",
    value: function fetchData(callback) {
      var _this3 = this;

      var _this$props = this.props,
          id = _this$props.id,
          onLoad = _this$props.onLoad;
      return this.client.collection(id, function (data) {
        _this3.setState({
          data: data
        });

        onLoad && onLoad(data);
        return callback(data);
      }, this.setError);
    }
  }, {
    key: "fetchStories",
    value: function fetchStories(callback) {
      var _this4 = this;

      var _this$props2 = this.props,
          endpoint = _this$props2.endpoint,
          id = _this$props2.id;
      var _this$state = this.state,
          page = _this$state.page,
          search = _this$state.search;
      return this.client.story('', id, page, search, function (data) {
        _this4.setState({
          stories: data.items,
          page: data.page,
          pageCount: data.last_page,
          totalCount: data.total_count,
          q: data.q //use q to keep the value persistent while a user is typing

        });

        return callback(data);
      }, this.setError);
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      // Used for a public interface of capturing key events
      var onChange = this.props.onChange;
      var _this$state2 = this.state,
          page = _this$state2.page,
          q = _this$state2.q;
      onChange && onChange({
        page: page,
        q: q
      });
    }
  }, {
    key: "handlePageChange",
    value: function handlePageChange(_ref) {
      var _this5 = this;

      var selected = _ref.selected;
      var newPage = selected + 1;
      if (newPage == this.state.page) return;
      this.setState({
        page: newPage,
        loading: true
      }, function () {
        _this5.fetchStories(function () {
          _this5.handleChange();

          _this5.setState({
            loading: false
          });
        });
      });
    }
  }, {
    key: "handleSearchInput",
    value: function handleSearchInput(event) {
      this.setState({
        search: event.target.value
      });
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(event) {
      var _this6 = this;

      event.preventDefault(); // prevent form from reloading page

      var searchQuery = this.state.search;
      this.setState({
        page: 1,
        loading: true
      }, function () {
        _this6.fetchStories(function () {
          _this6.handleChange();

          _this6.setState({
            loading: false
          });
        });
      });
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var errorComponent = this.props.errorComponent;
      return errorComponent || _react.default.createElement(_core.Typography, null, "Something went wrong while loading this collection... ", _react.default.createElement("br", null), "Try Refreshing or Check Back Soon");
    }
  }, {
    key: "render",
    value: function render() {
      var urlFormatter = this.props.urlFormatter;
      var _this$state3 = this.state,
          error = _this$state3.error,
          totalCount = _this$state3.totalCount,
          data = _this$state3.data,
          loading = _this$state3.loading,
          page = _this$state3.page,
          options = _this$state3.options,
          search = _this$state3.search,
          stories = _this$state3.stories,
          pageCount = _this$state3.pageCount,
          q = _this$state3.q;
      return error ? this.renderError() : _react.default.createElement(_Collection.default, _extends({
        loading: loading,
        stories: stories
      }, data, {
        count: totalCount,
        page: page,
        pageCount: pageCount,
        urlFormatter: urlFormatter,
        onPageChange: this.handlePageChange,
        search: search,
        q: q,
        onSearchInput: this.handleSearchInput,
        onSearch: this.handleSearch
      }, options));
    }
  }]);

  return StoriesAPICollection;
}(_react.Component);

exports.default = StoriesAPICollection;

_defineProperty(StoriesAPICollection, "propTypes", {
  /** API Key to interact with the StoriesAPI */
  apiKey: _propTypes.default.string.isRequired,

  /** Override `StoriesAPI` data fetching to use custom data */
  data: _propTypes.default.object,

  /** `StoriesAPI` endpoint URL */
  endpoint: _propTypes.default.string.isRequired,

  /** Current Browsing Page Number */
  page: _propTypes.default.number,

  /** StoriesAPI collection id */
  id: _propTypes.default.number.isRequired,

  /** Props to pass to the `Story` component */
  options: _propTypes.default.object
});

_defineProperty(StoriesAPICollection, "defaultProps", {
  data: null,
  endpoint: process.env.STORIES_API_URL,
  options: {},
  page: 1
});

;